import { lazy, Suspense } from 'react';
import PageMetaLoader from '../components/PageMetaLoader';
import OrganizationJsonLd from '../components/OrganizationJsonLd';

// Use lazy loading for all components
const DynamicHero = lazy(() => import('../components/Hero'));
const DynamicSolutionsSection = lazy(() => import('../components/SolutionsSection'));
const DynamicFeaturesSection = lazy(() => import('../components/FeaturesSection'));
const DynamicTestimonialsSection = lazy(() => import('../components/TestimonialsSection'));

const HomePage = () => {
  return (
    <div>
      <PageMetaLoader pageUrl="home" />
      <OrganizationJsonLd />
      <Suspense fallback={<div>Loading...</div>}>
        <DynamicHero />
        <DynamicSolutionsSection />
        <DynamicFeaturesSection />
        <DynamicTestimonialsSection />
        {/* <DynamicContactSection /> */}
      </Suspense>
    </div>
  );
};

export default HomePage;